const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

function countryCodeToEmoji(code: string): string {
  return code
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

export function CountryFlag({ code }: { code?: string | null }) {
  if (!code || code.length !== 2) {
    return null;
  }

  let title = code.toUpperCase();
  try {
    title = regionNames.of(code.toUpperCase()) || title;
  } catch {
    // unknown region code — keep the raw code as the tooltip
  }

  return (
    <span role="img" aria-label={title} title={title}>
      {countryCodeToEmoji(code)}
    </span>
  );
}
